{
  "appointment": {
    "CONFIRMATION_NUMBER": "確認番号",
    "APPOINTMENT_ID": "予約 ID",
    "APPOINTMENT_DATE": "予約日",
    "APPOINTMENT_TIME": "予約時刻",
    "APPOINTMENT_TIMEZONE": "タイムゾーン",
    "APPOINTMENT_TYPE": "予約の種類",
    "SCHEDULED_DURATION": "予定所要時間（分）",
    "STATUS": "ステータス",
    "ARRIVAL_DATE": "到着日",
    "ARRIVAL_TIME": "到着時刻",
    "DEPARTURE_DATE": "出発日",
    "DEPARTURE_TIME": "出発時刻",
    "DWELL_TIME": "滞在時間（分）",
    "ON_TIME": "定刻との差（分）",
    "IN_PROGRESS_DATE": "作業開始日",
    "IN_PROGRESS_TIME": "作業開始時刻",
    "WAIT_TIME": "待ち時間（分）",
    "PROCESSING_TIME": "作業時間（分）",
    "WAREHOUSE": "倉庫",
    "DOCK": "ドック",
    "LOAD_TYPE": "荷物の種類",
    "LOAD_TYPE_DIRECTION": "方向",
    "RESCHEDULE_COUNT": "日時変更回数",
    "CREATED_BY": "作成者",
    "CREATOR_TYPE": "作成者の種類",
    "CREATION_DATE": "作成日",
    "LAST_UPDATED_BY": "最終更新者",
    "LAST_UPDATE_DATE": "最終更新日",
    "LAST_UPDATE_TIME": "最終更新時刻",
    "CARRIER_COMPANY": "運送会社",
    "CONTACT_NAME": "担当者名",
    "CONTACT_EMAIL": "担当者のメールアドレス",
    "CONTACT_PHONE": "担当者の電話番号",
    "NOTES": "メモ",
    "TAGS": "タグ",
    "CUSTOM_FIELDS": "カスタム項目",
    "EXTERNAL_VALIDATION_STATUS": "外部検証ステータス",
    "EXTERNAL_VALIDATION_ERROR_MESSAGE": "外部検証エラーメッセージ",
    "CheckOut": "チェックアウト",
    "CheckInAdditionalAssetDetails": "チェックイン時のアセット追加情報",
    "InboundClaim": "入荷クレーム",
    "OutboundClaim": "出荷クレーム",
    "BookLoadType": "予約時の荷物の種類",
    "AssetContainerDetails": "アセット・コンテナの詳細",
    "AppointmentCompleted": "予約完了"
  },
  "assetVisit": {
    "id": "訪問 ID",
    "appointmentId": "予約 ID",
    "checkInDate": "チェックイン日時",
    "checkOutDate": "チェックアウト日時",
    "carrier": "運送会社",
    "warehouseName": "倉庫",
    "currentStatus": "ステータス",
    "licensePlate": "ナンバープレート",
    "visitType": "訪問の種類",
    "dotNumber": "DOT 番号",
    "phone": "電話",
    "isPlanned": "予定あり",
    "driverNotes": "ドライバーのメモ",
    "checkInAcknowledged": "チェックイン確認済み",
    "firstName": "本人確認：名",
    "lastName": "本人確認：姓",
    "birthdate": "本人確認：生年月日",
    "idValidationEmail": "本人確認：メールアドレス",
    "idValidationPhone": "本人確認：電話番号"
  }
}
